import * as React from 'react';
import "./Switch.scss"


type Props = {
    onChange(state: boolean): void,
    label: string
}

const Switch: React.FC<Props> = ({ onChange, label }) => {
    const [check, setCheck] = React.useState(false)

    const control = (newState: boolean) => {
        onChange(newState)
        setCheck(newState)
    }
    return (
        <label className="toggle">
            <input className="toggle-checkbox" type="checkbox" onChange={() => control(!check)} />
            <div className="toggle-switch"></div>
            <span className="toggle-label">{label}</span>
        </label>
    )
}

export default Switch